<template>
  <div id="s4s2" class="scroll-page">
    <div class="notice" :style="showNotice?'max-height:110px;':'max-height:0;'">
      <div class="notice-content" @click="handleTapNotice">
        <div class="notice-text" :style="showNotice?'':'animation:none;'">
          {{"重要通知：本小程序“违章缴费”将业务合并到“罚单缴费”小程序并于1月19日下线，可搜索“罚单缴费”小程序进行业务办理如有不便，敬请谅解。"}}
        </div>
      </div>
    </div>
  <swiper-ad :list="bannerList" v-if="!advertisingShow"/>
    <!-- ai识别罚单弹出框 start -->
    <div v-if="showTicketDialog" class="ticket-dialog">
    <div class="s4s-mask" onTap="hideDetailm"></div>
    <div class="ticket-dialog-container">
      <div class="ticket-dialog-title">处罚决定书确认</div>
      <div class="ticket-dialog-content">
        <div class="ticket-dialog-content-text">请查看您收到的是处罚决定书还是告知单（如下图所示），处罚决定书可继续办理在线罚单缴费</div>
        <div class="ticket-dialog-img-box"><img class="ticket-dialog-image" mode="aspectFill" src="https://app.s4s.cn/razio/ai_first_help4.png" /></div>
      </div>
      <div class="ticket-dialog-btn-container">
        <div class="ticket-dialog-btn" @click="goOnTicket">继续办罚单</div>
        <div v-if="showIllegalTab" class="ticket-dialog-btn" @click="gotoIllegal">告知单处理</div>
      </div>
    </div>
  </div>
  <!-- <div v-if="showfailDialog" class="ticket-dialog">
    <div class="s4s-mask" onTap="hideDetailm"></div>
    <div class="ticket-dialog-container">
      <div class="ticket-dialog-title">识别失败</div>
      <div class="ticket-dialog-content">
        <div class="ticket-dialog-content-text">请确认上传的图片为处罚决定书</div>
        <div class="ticket-dialog-img-box"><img class="ticket-dialog-image2" mode="aspectFill" src="https://app.s4s.cn/razio/showfailDialog.png" /></div>
      </div>
      <div class="ticket-dialog-btn-container">
        <div class="ticket-dialog-btn" @click="handleWrite">手动填写</div>
        <div class="ticket-dialog-btn" @click="reUpload">重新拍照</div>
      </div>
    </div>
  </div> -->
  <!-- ai识别罚单弹出框 end -->
<div class="s4s-page1">
    <div style="margin: 0 15px;">
    <div class="ai-container" v-if="isAi" >
      <div class="ai-title flex">
        <div class="flex">处罚决定书</div>
        <div class="flex ai-pen-text" @click="handleChangeInputType"><img src="https://app.s4s.cn/razio/ai_pen.png" mode="aspectFit" class="ai-pen" />手动填写</div>
      </div>
      <div class="ai-tap-container" @click="uploadImage">
        <div class="huxi-box">
          <img src="https://s4s-images.oss-cn-shanghai.aliyuncs.com/alipay_vio/huxi.png" mode="aspectFit" class="ai-huxi" />
          <img src="https://s4s-images.oss-cn-shanghai.aliyuncs.com/alipay_vio/xj.png" mode="aspectFit" class="ai-xj" />
          <img src="https://s4s-images.oss-cn-shanghai.aliyuncs.com/alipay_vio/xiantiao.png" mode="aspectFit" class="ai-xiantiao" />
          <div class="ai-pic-text">
            <img src="https://s4s-images.oss-cn-shanghai.aliyuncs.com/alipay_vio/icon_tishi.png" mode="aspectFit" class="ai-tishi" />
          </div>
        </div>
        <input
          ref="file"
          id="file"
          type="file"
          accept="image/*"
          multiple="multiple"
          style="display: none;"
          @change="fileChanged">
        <canvas id="canvas" style="display: none;"></canvas>
      </div>
      <div class="t-notice">
        <div class="t-notice-desc" style="padding: 0;text-align: left">
          <div>
            · 罚单缴费后<span style="color:#3a82ff;font-weight:500;display:inline;">24小时内处理完成</span>，非实时办理。
          </div>
          <div>
            · 单条处罚决定书编号仅能处理一笔罚单，请勿合并处理。
          </div>
        </div>
      </div>
    </div>
    <div class="write-container" style="position: relative;" v-if="!isAi" >
      <div :class="isNoticeTrue ? 's4s-ticket' : 's4s-ticket s4s-ticket-error'">
        <div class="s4s-ticket-title">
            <div class="s4s-title">处罚决定书编号</div>
            <div class="s4s-help-text-ai" @click="handleChangeInputType">
              <img src="https://app.s4s.cn/razio/ai_pic2.png" class="ai-pen" />
              <span>拍照识别</span>
            </div>
        </div>
        <input type="idcard" class="s4s-ticket-input"
          :style="isNoticeTrue ? '' : 'color:#fd2900'"
          v-model="noticeNum"
          placeholder="请输入15-16位编号" maxlength="16" focus="focus"
        />
        <div v-if="error" class="s4s-error">{{error}}</div>
        <div :class="isCaptchaTrue? 's4s-ticket-cap-container' : 's4s-ticket-cap-container s4s-cap-error'"
          style="margin-top:10px;" v-if="showCaptcha"
          >
          <input class="s4s-ticket-cap" type="text"
            :style="isCaptchaTrue ? '' : 'color:#fd2900;'"
            v-model="captchValue" placeholder="请输入验证码" maxlength="4"
          />
          <img :src="captchUrl"  style="width:110px;height:25px;flex:1" @click="getCaptcha" />
        </div>
        <div class="t-notice">
          <div class="t-notice-desc">
            <div>
              · 罚单缴费后<span style="color:#3a82ff;font-weight:500;display:inline;">24小时内处理完成</span>，非实时办理。
            </div>
            <div>
              · 单条处罚决定书编号仅能处理一笔罚单，请勿合并处理。
            </div>
          </div>
        </div>
        <button type="primary" class="s4s-btn"
          @click="checkNoticeNum" :style="{backgroundImage:advertisingShow.backgroundImage}"> 立即办理 </button>
      </div>
    </div>
    <div :class="advertisingShow.channel === 'abchina' ?'s4s-copyright blod':'s4s-copyright'">
      <div>本服务由 <span class="blue" @click="gotoMys4s">齐车大圣</span> 提供，客服电话：
        <a class="s4s-copyright-phone" href="tel://0571-26281166"  >0571-26281166</a>
      </div>
    </div>
    <div class="write-help-container" style="">
      <div class="write-help-container-title">
        <img class="" mode="aspectFill" src="https://app.s4s.cn/razio/attention_icon.png" />
        <span v-if="!isAi">请填写 [处罚决定书编号] 而不是 [告知单编号]</span>
        <span v-if="isAi">请上传或拍摄 [处罚决定书] 而不是 [告知单] 图片</span>
      </div>
      <div class="write-help-container-one">
        <div>处罚决定书示意图</div>
        <img class="" mode="aspectFill" src="https://app.s4s.cn/razio/ticket_one.png" />
      </div>
      <div class="write-help-container-one">
        <div>违停告知单示意图</div>
        <img class="" mode="aspectFill" src="https://app.s4s.cn/razio/notice_ticket_one.png" />
      </div>
      <div class="write-help-tip">图片仅供参考，请以实际现场单或处罚决定书为准</div>
    </div>
  <div class="s4s-mask" @click="hideImage" v-if="helpImageSrc">
      <img :src="helpImageSrc" class="s4s-mask-image" />
  </div>
  </div>
  <div class="s4s-mask-loading" v-if="showMask"></div>
</div>
   <!-- 资讯 -->
  <a ref="movecar"  href="https://detail.m.tmall.com/item.htm?spm=a220m.1000858.1000725.1.67065fe1cQDg8v&id=568820639768&areaId=330100&user_id=3854958416&cat_id=2&is_b=1&rn=ef6767ee33437d5347ae5fc16b4e6910"></a>
  <a ref="baiduyqh" href="https://jin.baidu.com/mkt/cloan/guide?code=0122huoke01&channel=JXJhuoke&spot=qichedasheng-201808219"></a>
  <div>
    <div v-if="data.length && !advertisingShow" class="s4s-ad">
      <div class="s4s-ad-header">
        <div class="s4s-ad-line" />
        <div class="s4s-ad-header-content">猜你想看</div>
        <div class="s4s-ad-line" />
      </div>
      <div class="s4s-ad-list">
        <div v-for="(item,index) in data" :key="item.id||item.title">
          <div class="s4s-ad-other" @click="gotoMovecar" v-if="parseInt(index % 10)===2" :key="index+'movecar_ad'">
            <img src="https://mys4s.cn/h5/img_vio/movecar_ad.jpg" />
          </div>
          <div class="s4s-ad-other" @click="gotoYQH" v-if="parseInt(index % 10)===3" :key="index+'baiduyqh'">
            <img src="https://mys4s.cn/h5/img_vio/baidu_yqh.png" />
          </div>

          <div class="s4s-ad-item" @click="gotoNews(item)">

           <div style="width:100%">
            <div v-if="item.cover_url1 || item.cover_url2 || item.cover_url3">
              <h4 class="s4s-ad-title">{{ item.title }}</h4>
              <div v-if="item.cover_url1 && item.cover_url2 && item.cover_url3 && (item.cover_url1!=item.cover_url2 && item.cover_url1!=item.cover_url3 && item.cover_url2!=item.cover_url3)" class="s4s-ad-images">
                <img :src='item.cover_url1' class="s4s-ad-small-image" />
                <img :src='item.cover_url2' class="s4s-ad-small-image" />
                <img :src='item.cover_url3' class="s4s-ad-small-image" />
              </div>
              <div v-else class="s4s-ad-image-container">
                <img :src="item.cover_url1 ||item.cover_url2 || item.cover_url3 " class="s4s-ad-image" />
              </div>

            </div>

          </div>
          <div class="s4s-ad-content">
              <div class="s4s-ad-time less-grey flex space-between">
                <div class="flex flex-center" v-if="item.Type===1" >
                  <span  class="s4s-ad-look flex" style="margin-right:18px">
                    <img src="../assets/icon/eye.png" style="margin-right:4px;vertical-align: middle;height:10px;">浏览{{item.show_num}}
                  </span>
                  <span  class="s4s-ad-look flex">
                    <img src="../assets/icon/like.png" style="margin-right:4px;vertical-align: middle;height:12px;">点赞{{item.like_num || 0}}
                  </span>
                </div>
                {{item.last_modify_time&&item.last_modify_time.substring(0,10)}}
              </div>
          </div>


          </div>
        </div>
      </div>
      <div v-if="loading" class="s4s-loading-more">
        正在加载...
      </div>
      <div v-else  class="s4s-loading-more">
        上拉加载更多
      </div>
    </div>

  </div>
  <!-- 资讯 -->
</div>
</template>

<script>
// @ is an alias to /src
import SwiperAd from '@/components/SwiperAd.vue';
import advertisingShow from './../utils/advertising';
import photoScan from '@/utils/photoScan';

let photoAnimate = null;

export default {
  name: 'ticket',
  components: {
    SwiperAd,
  },
  watch: {
    noticeNum(val) {
      // if (val.length > 16) {
      this.noticeNum = val&&val.replace(/[^\d]/g, '').substring(0, 16);
      // }
    },
  },
  data() {
    return {

      bannerList: [{
      //   id: 'banner_movecar2',
      //   name: '码上挪车',
      //   url: 'https://detail.tmall.com/item.htm?spm=a220m.1000858.1000725.21.67065fe12Hp3qY&id=568820639768&areaId=330100&user_id=3854958416&cat_id=2&is_b=1&rn=8dc3685735df4ec921fa3ad0ccb6f879',
      //   img: 'https://app.s4s.cn/h5vio/img/movecar_ad.jpg',
      // },
      // {
      //   id: 'banner_yqh2',
      //   name: '有钱花',
      //   url: 'https://jin.baidu.com/mkt/cloan/guide?code=0122huoke01&channel=JXJhuoke&spot=qichedasheng-201808219',
      //   img: 'https://app.s4s.cn/h5vio/img/baidu_yqh.png',
      // },
      // {
        id: 'renbaojiaxian',
        name: '驾乘意外保险',
        url: '',
        img: 'https://app.s4s.cn/h5vio/img/renbaojiaxian.jpg',
      },
      ],
      isAi: true,
      date: '', // 认罚日期
      breaklaw_time: '', // 违法时间
      address: '', // 违法地址
      city: '', // 违法城市
      carno: '', // 车牌号
      ticketUrl: '', // 上传罚单url
      price: '', // 罚款金额
      openShow: false,
      dateShow: false,
      lateFree: 0, // 滞纳金
      user: null,
      noticeNum: '',
      notify: null,
      nick: '',
      isquery: false,
      isqueryFail: true,
      nowDate: '',
      showDrive: false,
      driveNo: '',
      focus: false,
      quick: 0, // 是否支持加急 0不支持 1 支持
      click: false,
      isNoticeTrue: true,
      // ad
      page: 1,
      data: [],
      loading: false,
      error: '',
      helpImageSrc: '',

      captchKey: '',
      captchUrl: '',
      captchValue: '',
      showCaptcha: false,
      needCaptcha: false,
      isCaptchaTrue: true,
      advertisingShow: advertisingShow(),
      // showfailDialog: false,
      showTicketDialog: false,
      isGoOn: false,
      showIllegalTab: false,
      showMask:false,
      showNotice: false,
    };
  },
  activated() {
    if(this.advertisingShow.channel === 'abchina' ){
      document.getElementById('title').innerHTML = '罚单代办';
    }else{
      document.getElementById('title').innerHTML = '罚单缴费';
    }
  },
  mounted() {
    if (this.advertisingShow.channel === 'unionpay' || window.localStorage.getItem('viochannel') === 'unionpay') {
      this.showNotice = true
      upsdk.setTitleStyle({
        // 可选，导航栏(含状态栏)背景色及透明度。16进制，前2位(8F)透明度，后六位(FFFFFF)颜色，仅对当前页有效，其余页还是申请配置的导航默认颜色
        navBackgroundColor:'0x8FFFFFFF',
        appletStyle: 'black', //可选，black-黑色主题，white-白色主题
        backBtnVisible: '0', // 可选，左侧返回按钮是否显示。'0'不显示，'1'显示，不传或空则默认显示
        appletTitleBarVisible: '1',// 可选，标题栏是否显示。'0'不显示，'1'显示，默认显示
      })
      upsdk.setNavigationBarTitle({
        title: '罚单缴费'
      });
    }
    const nowChannel = window.localStorage.getItem('viochannel') || window.localStorage.getItem('advertising');
    // _czc.push(['_trackEvent', 'page', 'ticket', nowChannel + '','1','']); //eslint-disable-line
    this.configTab();
    // document.getElementById('title').innerHTML = '罚单代办';
    if(this.advertisingShow.channel === 'abchina' ){
      document.getElementById('title').innerHTML = '罚单代办';
    }else{
      document.getElementById('title').innerHTML = '罚单缴费';
    }
    this.getCaptcha();
    this.getAdUrl();
    this.showCaptcha = false;
    this.needCaptcha = false;

    if (this.$route.query && this.$route.query.redirect === '/ticket') {
      // 登录完成后
      this.noticeNum = this.$route.query.noticeNum;
      this.checkNoticeNum()
    }

    const s4s = document.getElementById('s4s2');
    s4s.addEventListener('scroll', () => {
      if (s4s.scrollHeight - s4s.scrollTop <= s4s.clientHeight + 300 && !this.loading) {
        this.load(this.page + 1);
      }
    });
    this.load(this.page, true);
    this.getNotice();
  },
  methods: {
    configTab() {
      const nowChannel = window.localStorage.getItem('viochannel') || window.localStorage.getItem('advertising');
      const notShowIllegalTab = ['xcarticket', 'abchina', '114h5', 'unionpay'];//   这个数组里的channel 不展示  违章tab页

      if (notShowIllegalTab.indexOf(nowChannel) !== -1) {
        this.showIllegalTab = false;
      } else {
        this.showIllegalTab = true;
      }
    },
    getAdUrl() {
      this.$request('v5/renbao/link').then((xhr, res) => {
        if (res.code === 0 && res.data) {
          this.bannerList[0].url = res.data;
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    getNotice() {
      this.$request('v3/violation/view/notice').then((xhr, res) => {
        if (res.code === 0 && res.data) {
          if (res.data.XcdHave) {
            this.XcdNotice = res.data.XcdNotice;
          }
        } else {
          this.XcdNotice = null;
        }
      }).catch((e) => {
        console.log(e);
        this.XcdNotice = null;
      });
    },
    gotoMys4s() {
      // _czc.push(['_trackEvent', '齐车大圣', 'current=1', 'ticket','','']); //eslint-disable-line
      window.location.href = 'https://mys4s.cn/#/driver?current=1';
    },
    getCaptcha() {
      this.$request('v3/captcha', {
        width: 180,
        height: 80,
        cap_len: 4,
        dot_count: 80,
        skew: 1,
      }).then((xhr, res) => {
        if (res.code === 0) {
          this.captchKey = res.data.key;
          this.captchValue = '';
          this.captchUrl = res.data.image;
        } else {
          this.$showToast({
            title: res.msg, // 文字内容
          });
        }
      });
    },
    gotoMovecar() {
      // _czc.push(['_trackEvent', '点击挪车', '跳转', '','','']); //eslint-disable-line
      this.$refs.movecar.click();
    },
    gotoYQH() {
      // _czc.push(['_trackEvent', '点击有钱花', '跳转', '','','']); //eslint-disable-line
      this.$refs.baiduyqh.click();
    },
    gotoHelp() {
      this.$router.push({
        path: '/help',
      });
    },
    load(page) {
      if (this.loading) {
        return;
      }
      this.started = true;
      this.loading = true;
      const params = {
        page_num: page || 1,
        list_id: 'ticket',
        address: 'vio:h5:news',
      };
      this.$request('v5/price/get_news_list', params).then((xhr, res) => {
        if (res.code === 0) {
          this.data = [...this.data, ...res.data];
          this.page = page;
        }
        this.loading = false;
      }).catch((e) => {
        console.log(e);
        this.loading = false;
      });
    },
    gotoNews({ id, Type, url }) {
      if (Type === 1) {
        window.open(`https://mys4s.cn/static/xcar/index.html#/News/${id}?token=${this.$store.getters.token}&xfrom=h5_vio`);
      } else if (Type === 2) {
        window.open(`https://mys4s.cn/h5/taro_valuation/index.html?token=${this.$store.getters.token}&xfrom=h5_vio`);
      } else if (Type === 3) {
        window.open(url);
      } else {
        window.open(url);
      }
    },
    checkLogin() {
      if (!this.$store.getters.userInfo || !this.$store.getters.token) {
        this.$router.push({
          path: '/login',
          query: {
            redirect: '/ticket',
          },
        });
        return false;
      }
      return true;
    },
    uploadImage() {
      // 招行提示，审核之后删除 start
      if (this.advertisingShow.channel === 'cmbapp' || this.advertisingShow.channel === 'cmbchange') {
        this.$showToast({
          icon: 'none',
          title: '系统维护中......', // 文字内容
        });
        return;
      }
      // 招行提示，审核之后删除 end
      if (!this.checkLogin()) return;
      this.$refs.file.click();
    },
    fileChanged() {
      const self = this;
      const list = this.$refs.file.files;
      if (list.length !== 1) {
        this.$showToast({ title: '最多只能选择1张罚单图片。' });
      }
      const item = {
        name: list[0].name,
        size: list[0].size,
        file: list[0],
      };
      self.html5Reader(list[0], item);
    },
    html5Reader(file, item) {
      const that = this;
      const imgSrc = new Image();
      const reader = new FileReader();
      reader.onload = (e) => {
        imgSrc.src = e.srcElement.result;
        that.$set(item, 'src', e.srcElement.result);
        imgSrc.onload = function () {//eslint-disable-line
          // 图片原始尺寸
          const originWidth = this.width;
          const originHeight = this.height;
          // 最大尺寸限制
          const maxWidth = 2000;
          const maxHeight = 2000;
          // 目标尺寸
          let targetWidth = originWidth;
          let targetHeight = originHeight;
          // 图片尺寸超过400x400的限制
          if (originWidth > maxWidth || originHeight > maxHeight) {
            if (originWidth / originHeight > maxWidth / maxHeight) {
              // 更宽，按照宽度限定尺寸
              targetWidth = maxWidth;
              targetHeight = Math.round(maxWidth * (originHeight / originWidth));
            } else {
              targetHeight = maxHeight;
              targetWidth = Math.round(maxHeight * (originWidth / originHeight));
            }
          }
          const canvas = document.getElementById('canvas');
          const context = canvas.getContext('2d');
          // canvas对图片进行缩放
          canvas.width = targetWidth;
          canvas.height = targetHeight;
          // 清除画布
          context.clearRect(0, 0, targetWidth, targetHeight);
          // 图片压缩
          context.drawImage(imgSrc, 0, 0, targetWidth, targetHeight);
          // canvas转为blob并上传
          const data = canvas.toDataURL('image/jpeg').split(',')[1];
          // 获取base64图片大小，返回MB数字
          const size = parseInt(data.length - data.length / 8 * 2);//eslint-disable-line
          if (size) {
            const isLt2M = size / 1024 / 1024 < 2;
            if (!isLt2M) {
              photoAnimate.stopAnimation(() => {
                that.$showToast({ title: '图片大小需要小于 2MB!' });
              });
              return;
            }
            that.$showToast({ title: '正在上传...', duration: 10000 });
            that.showMask = true
            that.handleAi(data);
            document.getElementById('file').value = ''; // 把input值置空，要不上传同一种图片change方法不生效
          }
        };
      };
      reader.readAsDataURL(file);
    },
    // ai 识别罚单
    handleAi(data) {
      const that = this;
      if (!this.$store.getters.userInfo || !this.$store.getters.token) {
        this.$router.push({
          path: '/login',
          query: {
            redirect: '/ticket',
            // noticeNum: this.noticeNum,
          },
        });
        this.$hideToast();
        // photoAnimate.stopAnimation();
        this.showMask = false;
        return;
      }
 
      this.$requestPost('v3/violation/recognition', {
        imageString: data,
      }).then((xhr, res) => {
        this.showMask = false;
        this.$hideToast();
          if (res.code === 0) {
            if (res.data && res.data[0]) {
              const successList = res.data;
              this.$store.commit('SET_AITICKETLIST', res.data);
              if (successList[0].type === '告知单') { // 告知单类型：弹出框提示
                this.showTicketDialog = true;
              } else if (successList[0].type === '其他') { // 其他类型 继续判断
                const reg = /(^\d{15}$)| (^\d{16}$)| (^\d{14}(\d|X|x)$)|(^\d{15}(\d|X|x)$)/;
                if (!successList[0].ticket) { // 无处罚编号 弹窗 识别失败
                  // this.showfailDialog = true; 
                  this.$router.push({
                    path: '/formWrap/ticketPay',
                    query: {
                      flag: 1
                    },
                  });
                  return;
                }
                if (successList[0].ticket.substr(6, 1) === '7') { // 则判断第七位是否为7
                  this.showTicketDialog = true;
                } else if (reg.test(successList[0].ticket)) { // 判断格式是否正确（15-16位数字），若正确，则进入罚单确认页面
                  this.checkNoticeNumIsReject(successList[0].ticket).then(res=>{
                    if(res){
                      this.$router.push({
                        path: '/formWrap/createOrder',
                        query: {},
                      });
                    }
                  })
                } else { // 若格式不正确，则弹窗告知识别不正确
                  // this.showfailDialog = true;
                  this.$router.push({
                    path: '/formWrap/ticketPay',
                    query: {
                      flag: 1
                    },
                  });
                  return;
                }
              } else { // 处罚决定书类型
                this.checkNoticeNumIsReject(successList[0].ticket).then(res=>{
                  if(res){
                    this.$router.push({
                      path: '/formWrap/createOrder',
                      query: {},
                    });
                  }
                })
              }
            } else {
              this.$store.commit('SET_AITICKETLIST', []);
              // this.showfailDialog = true;
              this.$router.push({
                path: '/formWrap/ticketPay',
                query: {
                  flag: 1
                },
              });
              return;
            }
          } else { // 识别失败
          console.log(456);
            // this.showfailDialog = true;
            this.$router.push({
              path: '/formWrap/ticketPay',
              query: {
                flag: 1
              },
            });
           return;
          }
      }).catch((e) => {
        this.$router.push({
          path: '/formWrap/ticketPay',
          query: {
            flag: 1
          },
        });
        return;
          // this.showfailDialog = true;
        // });
      });
    },
    checkNoticeNumIsReject(noticeNum){
      return new Promise((resolve, reject)=>{
        this.$request('v3/violation/fee', {
          notice_num: noticeNum
        }).then((xhr, res) => {
          if(res.code === 0){
            this.$store.commit('SET_TICKETCONFIG', res.data.Config);
            if(res.data.Config.IsReject === 1){
              resolve(true)
            }else{
              reject(false)
              this.$router.push({
                path: '/donthandle',
                query: {
                  noticeNum: noticeNum,
                },
              });
            }
          }else{
            resolve(true)
          }
        }).catch(()=>{
          resolve(true)
        })
      })
    },
    checkNoticeNum() {
      if (!this.$store.getters.userInfo || !this.$store.getters.token) {
        this.$router.push({
          path: '/login',
          query: {
            redirect: '/ticket',
            noticeNum: this.noticeNum,
          },
        });
        return;
      }
      const reg = /(^\d{15}$)| (^\d{16}$)| (^\d{14}(\d|X|x)$)|(^\d{15}(\d|X|x)$)/;
      if (!reg.test(this.noticeNum)) {
        this.isquery = false;
        this.isNoticeTrue = false;
        this.error = '请输入正确的15-16位违章决定书编号.';
        this.focus = true;
        return
      }else{
        this.isNoticeTrue = true;
        this.error = '';
      }
      this.$request('v3/violation/fee', {
        notice_num: this.noticeNum
      }).then((xhr, res) => {
        if(res.code == 0){
          this.$store.commit('SET_TICKETCONFIG', res.data.Config);
          if(res.data.Config.IsReject === 1){
            this.queryNoticeNum({ pass: true })
          }else{
            this.$router.push({
              path: '/donthandle',
              query: {
                noticeNum: this.noticeNum,
              },
            });
          }
        }else{
          this.queryNoticeNum({ pass: true })
        }
      })
    },
    // 文书号
    queryNoticeNum({ pass }) {
      // 招行提示，审核之后删除 start
      if (this.advertisingShow.channel === 'cmbapp' || this.advertisingShow.channel === 'cmbchange') {
        this.$showToast({
          icon: 'none',
          title: '系统维护中......', // 文字内容
        });
        return;
      }
      // 招行提示，审核之后删除 end

      if (this.XcdNotice && !pass) {
        this.$showModal({
          title: this.XcdNotice.Title,
          content: this.XcdNotice.Content,
          confirmText: '我知道了',
          confirmFn: () => {
            this.queryNoticeNum({ pass: true });
          },
        });
        return;
      }
      this.$showLoading({
        title: '加载中',
        mask: 'true',
      });
      // ？？？判断是不是告知单 第七位为7
      if (this.noticeNum.substr(6, 1) === '7' && !this.isGoOn) {
        this.showTicketDialog = true;
        this.ticketsType = 'write';
        this.$hideLoading();
        return;
      }
      this.isGoOn = false; // 清除继续下单状态
      const self = this;
      const reg = /(^\d{15}$)| (^\d{16}$)| (^\d{14}(\d|X|x)$)|(^\d{15}(\d|X|x)$)/;
      // 最后一位可以为 x
      if (reg.test(this.noticeNum)) {
        this.isNoticeTrue = true;
        this.error = '';
        // if (this.captchValue.length !== 4) {
        //   this.$hideLoading();
        //   this.isCaptchaTrue = false;
        //   this.error = '请输入正确的验证码';
        //   return;
        // }
        this.isCaptchaTrue = true;
        this.error = '';

        const param = {
          document: this.noticeNum,
        };
        const driveNum = this.noticeNum.substring(0, 2);
        if (Number(driveNum) === 15 || Number(driveNum) === 54) {
          this.showDrive = true;
        } else {
          this.showDrive = false;
        }
        // if (this.needCaptcha) {
        //   param.cap_value = this.captchValue;
        //   param.cap_key = this.captchKey;
        // }
        console.log('88888888');
        this.$router.push({
          path: '/formWrap/ticketPay',
          query: {
            noticeNum: this.noticeNum,
          },
        });
      } else {
        this.$hideLoading();
        self.isquery = false;
        self.isNoticeTrue = false;
        self.error = '请输入正确的15-16位违章决定书编号.';
        self.focus = true;
      }
    },
    handleChangeInputType() {
      // 招行提示，审核之后删除 start
      if (this.advertisingShow.channel === 'cmbapp' || this.advertisingShow.channel === 'cmbchange') {
        this.$showToast({
          icon: 'none',
          title: '系统维护中......', // 文字内容
        });
        return;
      }
      // 招行提示，审核之后删除 end
      this.isAi = !this.isAi;
    },
    // 关闭蒙层
    hideImage() {
      this.helpImageSrc = '';
    },
    // 发动机详情
    showImage(src) {
      this.helpImageSrc = src;
    },
    goOnTicket() {
      if (this.ticketsType == 'write') { // 手写单号流程还没有判断告知单类型！！！
        this.showTicketDialog = false;
        this.ticketsType = '';
        this.isGoOn = true;// 手写单号 继续办理
        this.queryNoticeNum({});
      } else { // ai识别单
        this.showTicketDialog = false;
        this.ticketsType = '';
        this.$router.push({
          path: '/formWrap/createOrder',
          query: {},
        });
      }
    },
    gotoIllegal() {
      this.showTicketDialog = false;
      this.ticketsType = '';
      this.$router.push({
        path: '/',
        query: {},
      });
    },
    handleTapNotice() {
      this.$showModal({
          title: "重要通知",
          content: "重要通知：本小程序“违章缴费”将业务合并到“罚单缴费”小程序并于1月19日下线，可搜索“罚单缴费”小程序进行业务办理如有不便，敬请谅解。",
          confirmText: '我知道了',
        });
    },
    // reUpload() { // 重新上传
    //   this.showfailDialog = false;
    //   this.uploadImage();
    // },
    // handleWrite() { // 手动填写
    //   this.showfailDialog = false;
    //   this.handleChangeInputType();
    // },
  },
};
</script>
<style lang="scss" scoped>
.s4s-page1 {
  padding: 0 !important;
  // box-sizing: border-box;
  // overflow-y: scroll;
  // overflow-x: hidden;
  // height: 100%;
}
.scroll-page{
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;
  background:#f8f8f8;
  padding-bottom: 60px;
}
.s4s-btn {
  display: block;
  width: 220px;
  height: 50px;
  border-radius: 50px;
  margin: 26px auto 0 ;
}

.s4s-pay-bg {
  background: #00a1ee url(../assets/icon/head_bg.png) no-repeat left bottom / 100%
    50px;
  width: 100%;
  height: 120px;
}

/* 抬头 */
.s4s-tips {
  margin-top: 10px;
  background: #fff;
  border-radius: 7px;
  padding: 10px;
  font-size: 14px;
  color: #666;
  display: flex;
}
.s4s-tips-tit {
  flex: 1;
  display: flex;
  align-items: center;
  color: #444444;
}
.s4s-tips-input {
  flex: 1;
  padding: 0 5px;
}
.s4s-tips-input input {
  text-align: right;
}
/* 抬头 */

.s4s-group image {
  width: 20px;
  height: 20px;
}
.s4s-sum {
  margin: 20px 10px 0 20px;
  flex: 1;
  align-items: center;
  text-align: left;
  font-size: 15px;
  color: #50b0de;
}
.s4s-sum text {
  color: #f40;
  padding-right: 5px;
}

.s4s-pop {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 9999;
  display: flex;
  width: 300px;
  margin-top: -50px;
  margin-left: -150px;
}
.s4s-pop-body {
  background-color: #fff;
  border-radius: 5px;
  padding: 10px;
  position: absolute;
}
.s4s-pop-title {
  background: rgba(37, 170, 255, 0.9);
  border-radius: 3px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  color: #fff;
  font-size: 17px;
  position: relative;
  z-index: 9999;
}
.s4s-pop-bg {
  background: #fff url(../assets/icon/help.png) no-repeat 5px 8px / 100% 100%;
  width: 100px;
  height: 100px;
  border-radius: 100px;
  position: absolute;
  left: 50%;
  top: -55px;
  margin-left: -50px;
  z-index: 99;
}
.s4s-close {
  width: 35px;
  height: 35px;
  margin: 125px auto 0 auto;
}

/* t-notice */
.t-notice {
  overflow: hidden;
  margin-top: 15px;
}
.t-notice-desc {
  color: #9C9EA8;
  background: #fff;
  font-size: 12px;
  line-height: 20px;
}
/* t-notice */

.s4s-notice-body {
  margin-top:10px;
  background: #fff;
  border-radius: 2px;
  padding: 0 15px;
}
.s4s-notice-body .s4s-group-tit {
  width:auto;
}

.s4s-ticket {
  background-color: #fff;
  border-radius: 4px;
  margin-top: 10px;
  padding: 26px 15px 28px;
  box-shadow: 0 2px 4px 0 #EFEFEF;
}
.s4s-ticket-title {
  display:  flex;
  margin-bottom: 23px;
  align-items: center;
}
.s4s-ticket-title .s4s-title {
  flex: 1;
  font-size: 16px;
  line-height: 22px;
  color: #24252D;
}
.s4s-ticket-input {
  width: 100%;
  background-color: #fff;
  font-size: 18px;
  color:#3A82FF;
  padding: 12px 14px;
  border-radius: 2px;
  border: 1px #eaeaea solid;
  box-shadow: none;
  box-sizing: border-box;
}
.s4s-ticket.s4s-ticket-error .s4s-ticket-input {
  border-color: #FD2900 !important;
  color: #FD2900 !important;
}

.input-placeholder {
  font-size: 15px;
}


.s4s-cap-error {
  border: 1px #FD2900 solid!important;
  color: #FD2900 !important;
}
.s4s-ticket-cap-container {
    background-color: #fff;
  font-size: 18px;
  display: flex;
  color:#3A82FF;
  padding: 12px 14px;
  border-radius: 2px;
  border: 1px #eaeaea solid;
}
.s4s-ticket-cap {
  width:7em;
  background-color: #fff;
  font-size: 18px;
  color:#3A82FF;
  flex: 2;
  border: none;
  box-sizing: border-box;
}
.s4s-help-text-ai {
  display: flex;
  align-items: center;
  color: #3A82FF;
  font-size: 12px;
}
.ai-pen {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
// .ai-pen-text{
//   color: #2468FA;
//   font-size: 24rpx;
// }
.s4s-copyright{
  text-align: center;
  margin-top: 10px;
}
.write-help-container{
  background:#fff;
  box-shadow: 0 2px 4px 0 #EFEFEF;
  border-radius: 4px;
  padding: 20px 15px;
  margin-top: 10px;
}
.write-help-container-title{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #9C9EA8;
}
.write-help-container-title img{
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.write-help-container-one{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight:bold;
  color: #3C4043;
  margin-top: 24px;
}
.write-help-container-one img {
  width: 315px;
  height:180px;
  margin-top: 15px;
}
.write-help-tip{
  font-size: 14px;
  color: #9c9ea8;
  margin-top: 15px;
  text-align: center;
}
.write-container{
  position: relative;background:#fff;
  box-shadow: 0 2px 4px 0 #EFEFEF;
  border-radius: 4px;
  margin-top: -30rpx;
  // padding-bottom: 28px;
}
.ai-container{
  z-index: 99;
  background: #fff;
  box-shadow: 0 2px 4px 0 #EFEFEF;
  border-radius: 4px;
  font-size: 14px;
  color: #24252D;
  margin-top: 10px;
  padding: 25px 15px 25px 15px;
  position: relative;
  text-align: center;
}

.ai-pic {
  width: 159px;
  height: 97px;
}
.ai-pic-text {
  color: #3C4043;
  font-size: 14px;
  position: relative;
  // bottom: -25.267vw;
  // margin-top: px;
}
.ai-pen {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.ai-pen-text{
  color: #2468FA;
  font-size: 12px;
}
.ai-title{
  justify-content: space-between;
}
.ai-title .flex{
  align-items: center;
}
.ai-title .flex:first-child{
 font-size: 16px;
 font-weight: bold;
}
.ai-tap-container {
  padding-top: 15px;
  position: relative;
  background: #F7F7F8;
  background-size: 42.4vw 25.867vw;
  // padding-bottom: 30px;
  margin: 22px 0;
  // height: 30vw;
  border-radius: 4px;
  overflow: hidden;
}
.huxi-box{
  position: relative;
}
.ai-huxi{
  z-index: 2;
  width: 100px;
  height: 100px;
  position: absolute;
  left:0px;
  top:-4px;
  bottom:0px;
  right:0px;
  margin:0px auto;
  animation-name: breath1;
  animation-duration: 1.5s;
  animation-timing-function: ease;
  animation-iteration-count: infinite;
}
.ai-xj{
  z-index: 5;
  width: 60px;
  height: 60px;
  position: absolute;
  left:1px;
  top:16px;
  bottom:0px;
  right:0px;
  margin:0px auto;
}
.ai-xiantiao{
  position: relative;
  z-index: 4;
  width: 159px;
  height: 92px;
}
.ai-pic {
  position: relative;
  z-index: 4;
  width: 159px;
  height: 92px;
}
@keyframes breath1 {
    from { transform: scale(1); }
    50%  { transform: scale(.75); }
    to   { transform: scale(1); }
}
.ai-tishi{
  width: 164px;
  height: 43px;

}
// 弹出框 start
.ticket-dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9999;
}
.ticket-dialog-container{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  font-size: 12px;
  background: #fff;
  border-radius: 2px;
  z-index: 200;
  width: calc(100% - 40px);
}

.ticket-dialog-btn-container {
  display: flex;
  border-top: 1px solid #efefef;
}

.ticket-dialog-btn {
  flex: 1;
  font-size: 15px;
  text-align: center;
  line-height: 21px;
  padding: 11px 0;
  color: #3A82FF;
  font-weight: 500
}
/* .ticket-dialog-btn:nth-child(2) {
  color:#fff;
  background-image: linear-gradient(-151deg, #105FF8 0%, #537EFF 100%);
} */
.ticket-dialog-btn:first-child {
  /* color:#5b5e6a; */
  border-right: 1px solid #efefef;
  /* background-color:#fff; */
}
.ticket-dialog-title{
  display: flex;
  font-size: 16px;
  color: #24252D;
  justify-content: center;
  height: 50px;
  font-weight:bold;
  align-items: center;
}
.ticket-dialog-content{
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ticket-dialog-content-text{
  font-size: 14px;
  color: #9C9EA8;
}
.ticket-dialog-image{
  width: 235px;
  height: 282px;
}
.ticket-dialog-image2{
  width: 235px;
  height: 135px;
}
.ticket-dialog-img-box{
  margin: 20px 0;
}
// 弹出框 end
</style>
